import axios, { type AxiosError, type AxiosInstance } from 'axios'

import { env } from '@/env'
import { ApiError } from '@/lib/api-error'

// Dev: baseURL vazia → request relativa cai no proxy do Vite (mesmo origin → cookie SameSite=Lax viaja).
// Prod: usa VITE_API_BASE_URL (origin da API) — obrigatório quando front e API ficam em domínios separados.
// Separado por domínio exige também cookie SameSite=None; Secure + CORS credentials no backend.
// Mesma base do axios, exportada para quem precisa navegar o BROWSER até a API (download, por
// exemplo) em vez de fazer XHR. Caminho relativo ali cairia no fallback da SPA quando front e
// API vivem em domínios separados — e o sintoma é a página recarregando em vez de baixar.
export const apiBaseUrl = import.meta.env.DEV ? '' : env.VITE_API_BASE_URL

export const api: AxiosInstance = axios.create({
  baseURL: apiBaseUrl,
  withCredentials: true,
  timeout: 15_000,
})

// Confirmação de e-mail: o 401 daqui é sobre o TOKEN do link (expirado/inválido), não sobre a
// sessão. Mandar para o login engoliria a única tela capaz de explicar isso e oferecer outro link.
const SESSION_AGNOSTIC_PATHS = ['/api/auth/verify-email']

export function onResponseError(err: AxiosError): Promise<never> {
  const requestUrl = err.config?.url ?? ''
  const isSessionAgnostic = SESSION_AGNOSTIC_PATHS.some((path) => requestUrl.startsWith(path))

  if (err.response?.status === 401 && !isSessionAgnostic && typeof window !== 'undefined') {
    const next = encodeURIComponent(window.location.pathname + window.location.search)
    if (!window.location.pathname.startsWith('/sign-in')) {
      window.location.assign(`/sign-in?next=${next}`)
    }
  }
  return Promise.reject(ApiError.fromAxiosError(err))
}

api.interceptors.response.use((res) => res, onResponseError)
